import {FC, ReactNode} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'

type FormTextHelperProps = {
  message: string | ReactNode
  bulletPoints?: string[]
  icon?: ReactNode
  textColor?: string
  textVariant?: TextVariant
  backgroundColor?: string
}

export const FormTextHelper: FC<FormTextHelperProps> = ({
  message,
  bulletPoints,
  icon,
  textColor = theme.palette.text.light,
  textVariant = TextVariant.text14,
  backgroundColor = theme.palette.gray[100],
}) => {
  return (
    <>
      <div className="helper">
        {icon && <div className="icon">{icon}</div>}
        <div>
          {typeof message === 'string' ? (
            <Text variant={textVariant} element="p" color={textColor}>
              {message}
            </Text>
          ) : (
            message
          )}
          {bulletPoints && (
            <ul className="list">
              {bulletPoints.map((item) => (
                <li key={item} className="item">
                  <Text variant={textVariant} element="p" color={textColor}>
                    {item}
                  </Text>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <style jsx>{`
        .helper {
          display: flex;
          padding: ${theme.spacing[1.5]} ${theme.spacing[2]};
          background-color: ${backgroundColor};
          border-radius: 5px;
        }
        .icon {
          margin-right: ${theme.spacing[2]};
        }
        .list {
          list-style-type: disc;
          margin-left: ${theme.spacing[4]};
          margin-top: ${theme.spacing[1]};
          color: ${textColor};
        }
        .item + .item {
          margin-top: ${theme.spacing[0.5]};
        }
      `}</style>
    </>
  )
}
